import React from 'react';
import './block.css';
import './mobile-block.css';

const Block = ({ data, number, images }) => {
  return (
    <div className="block">
      {
        images.map(image =>
          <img
            className={`image image-${image}`}
            src={`./images/${image}.png`}
            alt="small picture"
          />
        )
      }
      <div className="block__image-container">
        <img src={`./images/${data.image}.png`} alt="Изображение" className={`block__image block-image-${number}`}/>
        {
          number === 2
          ?
          <img className="block__rectangle rectangle-2" src="./images/rect-blue.png" alt=""/>
          :
          number === 3
          ?
          <img className="block__rectangle rectangle-3" src="./images/rect-purple.png" alt=""/>
          :
          number === 4
          ?
          <img className="block__rectangle rectangle-4" src="./images/rect-yellow.png" alt=""/>
          :
          null
        }
      </div>
      <h2 className="block__header">{data.header}</h2>
      <div className="block__text">
        <ol className="block__list" style={ data.list === "orderedList" ? { listStyle: "decimal" } : null }>
          {
            data.items.map((item, id) =>
              <li className="block__item" dangerouslySetInnerHTML={{ __html: item.text }} />
            )
          }
        </ol>
      </div>
    </div>
  )
}

export default Block;
